import { ErrorMessage } from "@hookform/error-message";
import { FieldErrors } from "react-hook-form";

import { Text } from "@/components/elements/Text";

export type InputErrorProps = {
  inputName: string;
  errors: FieldErrors;
};

export const InputError = ({ errors, inputName }: InputErrorProps) => {
  return (
    <div className="inputErrorContainer">
      {errors && (
        <ErrorMessage
          errors={errors}
          name={inputName}
          render={({ messages }) => {
            return (
              messages && (
                <>
                  {Object.entries(messages).map(([type, message]) => (
                    <Text as="span" key={type} size="xxs">
                      {message}
                    </Text>
                  ))}
                </>
              )
            );
          }}
        />
      )}
    </div>
  );
};
